import { atom } from "jotai";
import jwtDecode from "jwt-decode";
import { AuthUserState } from "../types/User/AuthUserState";

const forgeryToken = sessionStorage.getItem("@sisanForgeryToken");
const token = sessionStorage.getItem("@sisantoken");
const userDetails = localStorage.getItem("@sisanUserDetails");

let initialState: AuthUserState = {
  isAuthenticated: false,
  user: null,
  token: null,
  forgeryToken: null,
};

if (token && forgeryToken) {
  try {
    const decodedToken: any = jwtDecode(token);

    const parsedUserDetails = userDetails ? JSON.parse(userDetails) : {};
    initialState = {
      isAuthenticated: true,
      user: {
        id: decodedToken.nameid,
        email: decodedToken.email,
        name: decodedToken.unique_name,
        permissions: decodedToken.role,
        province: parsedUserDetails.provinceId
          ? {
              id: parsedUserDetails.provinceId ?? null,
              name: parsedUserDetails.provinceName ?? null,
            }
          : null,
        county: parsedUserDetails.countyId
          ? {
              id: parsedUserDetails.countyId ?? null,
              name: parsedUserDetails.countyName ?? null,
            }
          : null,
        role: parsedUserDetails.roleLevel
          ? {
              name: parsedUserDetails.roleName,
              level: {
                id: parsedUserDetails.roleLevel,
              },
            }
          : undefined,
        partner: parsedUserDetails.partner ?? decodedToken.partner ?? null,
      },
      token: token,
      forgeryToken,
    };
  } catch (error) {
    console.error("Invalid token", error);
  }
}

export const authAtom = atom<AuthUserState>(initialState);
